import { Tooltip as MuiTooltip, useTheme } from '@mui/material';
import type { TooltipProps as MuiTooltipProps } from '@mui/material';
import { colors } from 'styles/theme/colors';

export type TooltipProps = Pick<
  MuiTooltipProps,
  | 'title'
  | 'sx'
  | 'children'
  | 'arrow'
  | 'disableInteractive'
  | 'followCursor'
  | 'id'
  | 'onClose'
  | 'onOpen'
  | 'placement'
  | 'slots'
  | 'slotProps'
>;

export const Tooltip = ({
  sx,
  arrow = false,
  title,
  children,
  placement,
  disableInteractive = false,
  onOpen,
  onClose,
  slotProps,
  slots,
}: TooltipProps) => {
  const theme = useTheme();

  return (
    <MuiTooltip
      title={title}
      sx={{ marginTop: 0, ...sx }}
      arrow={arrow}
      onOpen={onOpen}
      onClose={onClose}
      placement={placement}
      disableInteractive={disableInteractive}
      slots={slots}
      followCursor
      slotProps={{
        arrow: { sx: { color: colors.grey[600] } },
        tooltip: {
          sx: {
            background: colors.grey[600],
            fontSize: theme.typography.smallTitle.fontSize,
            lineHeight: theme.typography.smallTitle.lineHeight,
            paddingX: theme.spacing(3),
            paddingY: theme.spacing(2),
          },
        },
        ...slotProps,
      }}
    >
      {children}
    </MuiTooltip>
  );
};
